module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/228.28a11220.png";